module.exports = __webpack_public_path__ + "assets/img/home-typical-scenarios-light-en.1ad11a34.png";